import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppId, AppThunkAPIType } from "../../../app/appTypes";
import { UrsGroup, URSRequirement, UrsRequirementType } from "../UrsSlice";
import { postWithAuth } from "../../../http";


export interface UrsConsistencyValidationResult {
    documentId: AppId;
    hasPlaceholders: boolean;
    hasEmptyGroups: boolean;
    hasEmptyTypes: boolean;
    requirementsWithPlaceholders: URSRequirement[];
    emptyGroups: UrsGroup[];
    emptyTypes: UrsRequirementType[];
}

export const validateUrsConsistency = createAsyncThunk<UrsConsistencyValidationResult, { documentId: AppId }, AppThunkAPIType
>("urs-validator/validate-consistency",
    async (data, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            postWithAuth({
                url: `api/urs-document-validator/${data.documentId}/validate-consistency`,
                payload: data,
            })
        );

        const { payload } = result;

        if (postWithAuth.fulfilled.match(result)) {
            return payload as UrsConsistencyValidationResult;
        } else {
            return rejectWithValue(payload ?? { kind: "unknown" });
        }
    }
);
